import { render, staticRenderFns } from "./IconList.vue?vue&type=template&id=c2949e6e&scoped=true"
import script from "./IconList.vue?vue&type=script&lang=js"
export * from "./IconList.vue?vue&type=script&lang=js"
import style0 from "./IconList.vue?vue&type=style&index=0&id=c2949e6e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2949e6e",
  null
  
)

export default component.exports